import { useDesignLayerProps } from "@/Pages/Admin/editor/shared-props";

export const useLocationOnInertiaNavigation = (initialLocation?: string) => {
    const { locationInfo } = useDesignLayerProps()?.designLayerProps;
    const location =
        locationInfo?.location || window.location.href || initialLocation;
    return new URL(location);
};
